export function lPEABillingDataAuthorizationRelease() {
return [   //2024 Release 2025-11-08 07:37:15
 {
   page: 0,
 name: "Logo",
 type: "logo",
 top: 28.673,
 left: 53,
 width: 240,
 height: 36,
 }, 
{
   page: 0,
   name: "accountNum", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 407.92,
   left: 275.28,
   width: 259.68,
   height: 15.054
}
,
{
   page: 0,
   name: "serviceAddress", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 439.48,
   left: 231.64,
   width: 302.04,
   height: 15.054
}
,
{
   page: 0,
   name: "nameOfAccountHolder", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 470.92,
   left: 73.0,
   width: 379.08,
   height: 15.054
}
,
{
   page: 0,
   name: "signature AccountHolder", 
   type: "signature",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 518.855,
   left: 72.0,
   width: 379.08,
   height: 15.054
}
] }
